import React from 'react';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { formatCountdown } from '../utils/clearClientStorage';

/**
 * @param {Object} directive   the pending directive from the server ({ mode: 'soft' | 'hard' })
 * @param {Number} remainingMs milliseconds left before the clear runs
 */
const CacheClearAlert = ({ directive, remainingMs }) => {
    if (!directive) return null;

    const isHard = directive.mode === 'hard';
    const msLeft = Math.max(0, remainingMs || 0);

    return (
        <div style={{ ...styles.wrapper, borderLeftColor: isHard ? '#C0392B' : '#F47D44' }}>
            <WarningRoundedIcon style={{ ...styles.icon, color: isHard ? '#C0392B' : '#F47D44' }} />
            <div>
                <div style={styles.title}>
                    {isHard ? 'You will be signed out' : 'Your cached data will be refreshed'}
                </div>
                <div style={styles.message}>
                    {isHard
                        ? 'An admin has cleared this session. Please save your work now.'
                        : 'An admin has cleared this browser\'s cache. The page will refresh — please save your work now.'}
                </div>
                <div style={{ ...styles.countdown, color: isHard ? '#C0392B' : '#F47D44' }}>
                    {msLeft > 0 ? `in ${formatCountdown(msLeft)}` : 'now...'}
                </div>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        position: 'fixed',
        right: 24,
        bottom: 24,
        zIndex: 20000,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        maxWidth: 340,
        padding: '14px 18px',
        backgroundColor: '#fff',
        borderRadius: 8,
        borderLeft: '5px solid',
        boxShadow: '0 4px 16px rgba(0,0,0,0.22)',
        fontFamily: 'Segoe UI, sans-serif',
    },
    icon: {
        fontSize: 26,
        marginTop: 2,
    },
    title: {
        fontSize: 15,
        fontWeight: 700,
        color: '#1C375D',
        marginBottom: 4,
    },
    message: {
        fontSize: 13,
        color: '#555',
        lineHeight: 1.45,
    },
    countdown: {
        fontSize: 14,
        fontWeight: 700,
        marginTop: 6,
    },
};

export default CacheClearAlert;
